import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LookupSource } from '../models/lookup-source.model';
import { environment } from '../../../environments/environment';

export interface PagedResult<T> {
      items: T[];
      totalCount: number;
}


@Injectable({ providedIn: 'root' })
export class LookupSourceService {
      private apiUrl = `${environment.apiUrl}/api/lookups`;

      constructor(private http: HttpClient) { }

      // getAll(): Observable<LookupSource[]> {
      //       return this.http.get<LookupSource[]>(this.apiUrl);
      // }
      getAll(pageIndex: number, pageSize: number, searchTerm: string = ''): Observable<PagedResult<LookupSource>> {
            let params = new HttpParams()
                  .set('pageIndex', pageIndex.toString())
                  .set('pageSize', pageSize.toString())
                  .set('searchTerm', searchTerm || '');

            return this.http.get<PagedResult<LookupSource>>(`${this.apiUrl}`, { params });
      }

      save(data: LookupSource): Observable<any> {
            return this.http.post(`${this.apiUrl}`, data);
      }

      delete(id: string): Observable<any> {
            return this.http.delete(`${this.apiUrl}/${id}`);
      }
}